<template>
    <div class="p-2 p-lg-4">
        <div class="row mb-4">
            <div class="col-6 ps-4 ms-2">
                <h2>{{ $t("titles.warehouses") }}</h2>
            </div>
            <div v-if="$store.getters.hasPerm('add_warehouse')" class="col-auto ms-auto">
                <router-link :to="{ name: 'AddWarehouse' }" class="button-top">{{ $t("warehouses.addWarehouse.label")
                }}</router-link>
            </div>
        </div>

        <LoadingSpinner :loading="loading" />

        <div class="list-group mb-5">
            <div v-for="warehouse in warehouses" :key="warehouse.id"
                class="list-group-item d-flex flex-wrap align-items-center gap-3 py-3">
                <div class="me-auto">
                    <div class="fw-bold">{{ warehouse.name }}</div>
                    <div class="text-muted small">{{ warehouse.address }}</div>
                </div>
                <router-link :to="{ name: 'WarehouseStock', params: { id: warehouse.id } }"
                    class="btn btn-primary text-white">
                    {{ $t("warehouses.resources") }}
                </router-link>
                <router-link v-if="$store.getters.hasPerm('add_warehouse')" :to="'/warehouse/' + warehouse.id + '/edit'"
                    class="btn btn-outline-dark">
                    {{ $t("warehouses.edit") }}
                </router-link>
                <button v-if="$store.getters.hasPerm('delete_warehouse')" @click="hideWarehouse(warehouse.id)"
                    class="btn btn-outline-danger">
                    {{ $t("warehouses.dontUse") }}
                </button>
            </div>
        </div>

        <div v-if="warehouses.length > 1">
            <div class="d-flex flex-wrap justify-content-between align-items-center mb-2">
                <h3 class="text-primary mb-0">{{ $t("warehouses.stockOverview") }}</h3>
                <div class="form-check">
                    <input v-model="showEmpty" class="form-check-input" type="checkbox" id="showEmpty" />
                    <label class="form-check-label" for="showEmpty">{{ $t("warehouses.showEmpty") }}</label>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-striped table-hover align-middle">
                    <thead>
                        <tr>
                            <th>{{ $t("warehouses.product") }}</th>
                            <th v-for="warehouse in warehouses" :key="warehouse.id" class="text-end text-nowrap">
                                <router-link :to="{ name: 'WarehouseStock', params: { id: warehouse.id } }">
                                    {{ warehouse.name }}
                                </router-link>
                            </th>
                            <th class="text-end">{{ $t("warehouses.total") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="product in shownProducts" :key="product.id">
                            <td class="text-nowrap">
                                <span class="fw-bold me-2">{{ product.shorten_name }}</span>
                                <span class="text-muted small">{{ product.measurement_unit }}</span>
                            </td>
                            <td v-for="warehouse in warehouses" :key="warehouse.id" class="text-end text-nowrap"
                                :class="amountClass(product.amounts[warehouse.id])">
                                {{ product.amounts[warehouse.id] ? formatAmount(product.amounts[warehouse.id]) : "–" }}
                            </td>
                            <td class="text-end text-nowrap fw-bold" :class="amountClass(total(product))">
                                {{ formatAmount(total(product)) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
    components: {
        LoadingSpinner
    },
    data() {
        return {
            warehouses: [],
            products: [],
            showEmpty: false,
            loading: true
        }
    },
    created() {
        this.loadData();
    },
    computed: {
        shownProducts() {
            if (this.showEmpty) return this.products;
            return this.products.filter((product) => Object.keys(product.amounts).length > 0);
        }
    },
    methods: {
        loadData() {
            this.$store.getters.api.get("/warehouses/stock").then((response) => {
                this.warehouses = response.data.warehouses;
                this.products = response.data.products;
                this.loading = false;

                if (this.warehouses.length === 1 && !this.$store.getters.hasPerm("can_view_all_warehouses")) {
                    this.$router.replace({ name: "WarehouseStock", params: { id: this.warehouses[0].id } });
                }
            });
        },
        total(product) {
            return Object.values(product.amounts).reduce((sum, amount) => sum + amount, 0);
        },
        amountClass(amount) {
            if (amount < 0) return "text-danger";
            if (!amount) return "text-muted";
            return "";
        },
        hideWarehouse: function (id) {
            this.$store.getters.api.delete("/warehouse/" + id + "/hide").then((response) => {
                this.loadData();
            }).catch((response) => {
                alert(this.$t("error." + response?.response?.data?.error_code));
            });
        },
    },
}
</script>
